import React from 'react';
import { BadgeCheckIcon, FileCheck2Icon, GiftIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#09281d] px-5 py-20" data-id="element-78">
      <div className="mx-auto max-w-3xl border-t-8 border-emerald-400 bg-white p-8 text-center shadow-2xl sm:p-14" data-id="element-79">
        <p className="inline-flex items-center gap-2 bg-emerald-500 px-4 py-2 text-xs font-bold uppercase tracking-widest text-white" data-id="element-80">
          <BadgeCheckIcon className="h-4 w-4" data-id="element-81" /> Zero rischi · 100% protetto
        </p>
        <ShieldCheckIcon className="mx-auto mt-7 h-20 w-20 text-emerald-700" strokeWidth={1.4} data-id="element-82" />
        <h2 className="mt-6 font-display text-5xl font-bold uppercase leading-none text-[#09281d] sm:text-6xl" data-id="element-83">
          Garanzia di <span className="text-emerald-700" data-id="element-84">7 giorni</span>
        </h2>
        <p className="mx-auto mt-6 max-w-lg text-lg font-medium text-slate-600" data-id="element-85">
          Apri tutto. Usa il materiale. Mettilo alla prova in palestra.
        </p>
        <p className="mt-5 text-2xl font-bold leading-tight text-[#09281d]" data-id="element-86">
          Se PALLAVOLO PRONTA non trasforma il modo in cui pianifichi e gestisci
          i tuoi allenamenti,{' '}
          <span className="text-emerald-700" data-id="element-87">
            ti rimborseremo ogni centesimo — senza fare domande.
          </span>
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-3 text-xs font-bold text-[#09281d]" data-id="element-88">
          <span className="flex items-center gap-1.5" data-id="element-89">
            <ZapIcon className="h-4 w-4 text-emerald-700" data-id="element-90" /> Rimborso istantaneo
          </span>
          <span className="flex items-center gap-1.5" data-id="element-91">
            <FileCheck2Icon className="h-4 w-4 text-emerald-700" data-id="element-92" /> Nessun
            modulo da compilare
          </span>
          <span className="flex items-center gap-1.5" data-id="element-93">
            <GiftIcon className="h-4 w-4 text-emerald-700" data-id="element-94" /> Tieni i bonus
          </span>
        </div>
        <p className="mt-6 inline-block border border-emerald-500/40 bg-emerald-50 px-4 py-2 text-xs font-bold uppercase tracking-widest text-emerald-800" data-id="element-95">
          Tasso di rimborso inferiore all’1%
        </p>
      </div>
    </section>;
}